// extracted by mini-css-extract-plugin
export var avatarContainer = "_d4-0";
export var avatarTypingWave = "_d4-i";
export var gray = "_d4-f";
export var green = "_d4-c";
export var icon = "_d4-9";
export var image = "_d4-1";
export var lg = "_d4-6";
export var md = "_d4-5";
export var presenceDot = "_d4-b";
export var red = "_d4-d";
export var sm = "_d4-4";
export var status = "_d4-a";
export var typingDot = "_d4-h";
export var typingPill = "_d4-g";
export var xl = "_d4-7";
export var xs = "_d4-3";
export var xxl = "_d4-8";
export var xxs = "_d4-2";
export var yellow = "_d4-e";